export const MATCH_ALL_EXCEPT_SIMPLE_CHARS_NUMBERS_AND_DASH = /[^a-zA-Z0-9\-_]+/g;

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
